// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Input, Output, EventEmitter, Component, OnInit } from '@angular/core';
import { MembershipTier, SubtierId, MembershipSubtier, MembershipTierSelected } from '@app/core';

@Component({
  selector: 'app-membership-tier',
  templateUrl: './membership-tier.component.html',
  styleUrls: ['./membership-tier.component.scss']
})
export class MembershipTierComponent implements OnInit {
  @Input() tier: MembershipTier | undefined = undefined;
  @Input() selectedTierId: string | undefined = undefined;
  @Input() selectable = false;

  @Output() selected = new EventEmitter<MembershipTierSelected>();

  constructor() {}

  ngOnInit() {}

  select(tier: MembershipTier, subtier: MembershipSubtier) {
    const tierSelected: MembershipTierSelected = {
      ...tier,
      subtier
    };
    this.selected.emit(tierSelected);
  }

  public membershipSubtierId(subtierId: SubtierId) {
    return subtierId;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/membership-tier/membership-tier.component.ts